import React, { Component } from 'react';

import { Modal, Thumbnail, Button, Grid, Row, Col} from 'react-bootstrap';

import dieter from './images/mitarbeiter/dieter_mrochen_v2.jpg';
import ulli from './images/mitarbeiter/ulrich_faber.png';
import robert from './images/mitarbeiter/robert_zeilinger.png';
import janz from './images/mitarbeiter/avatar.png';
import walter from './images/mitarbeiter/avatar.png';
import horst from './images/mitarbeiter/avatar.png';
import jan from './images/mitarbeiter/jan_mrochen.jpg';
import elrica from './images/mitarbeiter/elrica_mrochen.jpg';
import sybille from './images/mitarbeiter/sybille_mrochen_v2.jpg';
import britta from './images/mitarbeiter/britta_volland.jpg';

class Kontakt extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      person: 'Dieter Mrochen',
      email: 'dieter.mrochen@mauersberger-vertrieb.de',
      mobil: '0175/4678779',
      telefon: '09127/903866',
      mailto: 'mailto:dieter.mrochen@mauersberger-vertrieb.de',
      calltoMobile: 'tel:01754678779',
      calltoPhone: 'tel:09127903866'
    };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(dataPerson) {
    switch(dataPerson) {
        case 'dieter':
          this.setState({person: 'Dieter Mrochen', email: 'info@mauersberger-vertrieb.de', mobil: '0175/4678779', telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de', calltoMobile: 'tel:01754678779', calltoPhone: 'tel:09127903866'});
          break;
        case 'robert':
          this.setState({person: 'Robert Zeilinger', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'ulli':
          this.setState({person: 'Ulrich Faber', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'janz':
          this.setState({person: 'Zeilinger Jan', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'horst':
          this.setState({person: 'Neeser Horst', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'walter':
          this.setState({person: 'Fricke Walter', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'sybille':
          this.setState({person: 'Sybille Mrochen', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'britta':
          this.setState({person: 'Britta Volland', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'elrica':
          this.setState({person: 'Elrica Mrochen', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        case 'jan':
          this.setState({person: 'Jan Mrochen', email: 'info@mauersberger-vertrieb.de', mobil: null, telefon: '09127/903866', mailto: 'mailto:info@mauersberger-vertrieb.de',  calltoPhone: 'tel:09127903866'});
          break;
        default:
          break;
        }
    this.setState({ show: true });
  }


  render() {
    var classMobile = "";

    if(this.state.mobil === null){
          classMobile = "displayNone";
      }

    return (
      <div className='container-fluid'>
        <center>
        <h1> Kontakt </h1>
        </center>
        <Grid>
          <Row>
            <Col xs={6} md={4}>
              <Thumbnail src={dieter} alt="Dieter Mrochen">
                <h3>Dieter Mrochen</h3>
                <p>Geschäftsführer</p>
                <br/>
                <p>
                  <Button bsStyle="primary" onClick={() => this.handleShow('dieter')}>Kontakt</Button>&nbsp;
                </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={sybille} alt="Sybille Mrochen">
              <h3>Sybille Mrochen</h3>
              <p className="wordWrap">Kaufmännische Geschäftsführung, <br/> Marketing und Organisation</p>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('sybille')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={ulli} alt="Ulrich Faber">
                <h3>Ulrich Faber</h3>
                <p className="wordWrap">Vertrieb Spannsysteme <br/> Werkzeugmaschinen</p>
                <p>
                  <Button bsStyle="primary" onClick={() => this.handleShow('ulli')}>Kontakt</Button>&nbsp;
                </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={robert} alt="Robert Zeilinger">
              <h3>Robert Zeilinger</h3>
              <p className="wordWrap">Vertrieb Spannsysteme <br/> Werkzeugmaschinen</p>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('robert')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={janz} alt="Jan Zeilinger">
              <h3>Jan Zeilinger</h3>
              <p className="wordWrap">Vertrieb Spannsysteme <br/> Werkzeugmaschinen</p>
              <br/>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('janz')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={walter} alt="Walter Fricke">
              <h3>Walter Fricke</h3>
              <p className="wordWrap">Vertrieb Spannsysteme <br/> Werkzeugmaschinen</p>
              <br/>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('walter')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={britta} alt="Britta Volland">
              <h3>Britta Volland</h3>
              <p>Innendienst</p>
              <br/>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('britta')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={elrica} alt="Elrica Mrochen">
              <h3>Elrica Mrochen</h3>
              <p>Innendienst</p>
              <br/>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('elrica')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
            <Col xs={6} md={4}>
              <Thumbnail src={jan} alt="Jan Mrochen">
              <h3>Jan Mrochen</h3>
              <p>IT Consulting & Software Services</p>
              <br/>
              <p>
                <Button bsStyle="primary" onClick={() => this.handleShow('jan')}>Kontakt</Button>&nbsp;
              </p>
              </Thumbnail>
            </Col>
          </Row>
        </Grid>
        <Modal show={this.state.show} onHide={this.handleClose} >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.person}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Telefon: <Button href={this.state.calltoPhone} bsStyle="link">{this.state.telefon}</Button></h4>
            <h4 className={classMobile}>Mobil: <Button href={this.state.calltoMobile} bsStyle="link">{this.state.mobil}</Button></h4>
            <h4>E-Mail: <Button href={this.state.mailto} bsStyle="link">{this.state.email}</Button></h4>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Schließen</Button>
          </Modal.Footer>
        </Modal>

      </div>

    );
  }
}

export default Kontakt;



// WEBPACK FOOTER //
// ./src/components/pages/kontakt.js